var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333984,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#DDF0EB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_852_10564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.386 13.4248V18.904C10.386 19.4487 10.6077 19.9714 11.0029 20.3563C11.4012 20.7435 11.9351 20.9596 12.4906 20.9583H18.1026C18.6608 20.9583 19.1958 20.7417 19.5903 20.3563C19.7849 20.1676 19.9397 19.9419 20.0456 19.6925C20.1516 19.4431 20.2065 19.175 20.2072 18.904V13.4248M10.386 13.4248C9.80455 13.4248 9.33398 12.9645 9.33398 12.3973V11.0275C9.33398 10.4602 9.80519 10 10.386 10H20.2072C20.7887 10 21.2592 10.4602 21.2592 11.0275V12.3973C21.2592 12.9645 20.788 13.4248 20.2072 13.4248M10.386 13.4248H20.2072",
    stroke: "#439771",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2969 18.7016V15.4785",
    stroke: "#439771",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8184 17.3457L15.0863 18.6136C15.1139 18.6413 15.1466 18.6633 15.1827 18.6783C15.2187 18.6933 15.2574 18.701 15.2964 18.701C15.3355 18.701 15.3742 18.6933 15.4102 18.6783C15.4463 18.6633 15.479 18.6413 15.5066 18.6136L16.7745 17.3457",
    stroke: "#439771",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_852_10564"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(8.33398 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.16ec6cb0bd35d4bd29fab36b932f0696.svg";
export { ForwardRef as ReactComponent };